export enum LanguageEnum {
    En = 'en',
    Ru = 'ru'
}
